export default __webpack_public_path__ + "static/media/wallet.c15eee26.svg";